import { gql } from '@apollo/client'

export const challengeExtraDraftsMutation = gql`
  mutation ChallengeExtraDrafts($challenge: String!) {
    challengeExtraDrafts(challenge: $challenge)
  }
`
